import client from "@/apiClient";

// ── Voyage CRUD ─────────────────────────────────────────────────
export const listVoyages = ({ status, limit = 50, offset = 0 } = {}) => {
  const params = { limit, offset };
  if (status) params.status = status;
  return client.get("/voyages", { params }).then((r) => r.data);
};

export const getVoyage = (id) =>
  client.get(`/voyages/${id}`).then((r) => r.data);

export const createVoyage = (data) =>
  client.post("/voyages", data).then((r) => r.data);

export const updateVoyage = (id, data) =>
  client.put(`/voyages/${id}`, data).then((r) => r.data);

export const deleteVoyage = (id) => client.delete(`/voyages/${id}`);

export const duplicateVoyage = (id, data) =>
  client.post(`/voyages/${id}/duplicate`, data).then((r) => r.data);

// ── Calendar endpoints ──────────────────────────────────────────
export const calendarParse = (file) => {
  const form = new FormData();
  form.append("file", file);
  return client
    .post("/voyages/calendar/parse", form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const calendarImport = (file, mapping) => {
  const form = new FormData();
  form.append("file", file);
  form.append("sheet_name", mapping.sheet_name);
  form.append("header_row", String(mapping.header_row));
  form.append("date_col", String(mapping.date_col));
  if (mapping.port_col != null) form.append("port_col", String(mapping.port_col));
  if (mapping.departure_col != null) form.append("departure_col", String(mapping.departure_col));
  if (mapping.arrival_col != null) form.append("arrival_col", String(mapping.arrival_col));
  if (mapping.sea_port_col != null) form.append("sea_port_col", String(mapping.sea_port_col));
  // Phase 7+ — when both windowing inputs are present, the backend
  // filters the import down to [start_date, start_date + total_days - 1]
  // and fills any missing dates with Sea days.
  if (mapping.start_date) form.append("start_date", mapping.start_date);
  if (mapping.total_days) form.append("total_days", String(mapping.total_days));
  return client
    .post("/voyages/calendar/import", form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// ── Ships (from library) ────────────────────────────────────────
export const listShips = () =>
  client.get("/lib/ships").then((r) => r.data);
